import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export var Indicator = function Indicator(props) {
  var indicator = props.indicator,
    total = props.total,
    current = props.current;
  if (indicator === '1') {
    return _jsx("div", Object.assign({
      className: 'relative'
    }, {
      children: _jsx("ul", Object.assign({
        className: 'absolute right-2 -top-8 z-2 flex items-center justify-center mb-0 w-full h-10'
      }, {
        children: Array.from({
          length: total
        }).map(function (_, index) {
          return _jsx("li", {
            className: classNames('inline-block rounded-full transition-all duration-1000', {
              'ml-0': index === 0,
              'ml-3': index !== 0,
              'w-2 h-2 bg-gray-400': index === current,
              'w-1.5 h-1.5 bg-gray-200': index !== current
            })
          }, index);
        })
      }))
    }));
  }
  if (indicator === '2') {
    return _jsx("div", Object.assign({
      className: 'relative'
    }, {
      children: _jsx("ul", Object.assign({
        className: 'absolute left-0 -top-8 z-2 flex items-center justify-center w-full h-10'
      }, {
        children: Array.from({
          length: total
        }).map(function (_, index) {
          return _jsx("li", {
            className: classNames('inline-block w-6 h-1 shadow transition-all duration-1000', {
              'ml-0': index === 0,
              'ml-2': index !== 0,
              'bg-black': index === current,
              'bg-white': index !== current
            })
          }, index);
        })
      }))
    }));
  }
  return _jsx("div", Object.assign({
    className: 'relative'
  }, {
    children: _jsxs("div", Object.assign({
      className: 'absolute right-2 -top-6 z-2 inline-block px-2 text-xs bg-[rgba(0,0,0,0.8)] text-white rounded-full'
    }, {
      children: [total, "/", current + 1]
    }))
  }));
};